export default "__VITE_ASSET__B6a5EohD__"